import React, { useEffect, useState } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { Link, NavLink, Redirect } from "react-router-dom";
import Filters from "./Filters";
import Products from "./Products";
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import keys from "../store/keys";

function Home({ session, setKey, ...props }) {

	const [showCookiePolicy, setShowCookiePolicy] = useState(false);

	useEffect(() => {
		if(!session.cookiesAccepted || session.cookiesAccepted === "false") {
			setShowCookiePolicy(true);
		}
	}, []);

	const handleAccept = e => {
		e.preventDefault();
		setKey(keys.cookiesAccepted, true);
		setShowCookiePolicy(false);
	}

	const handleReject = e => {
		e.preventDefault();
		setKey(keys.cookiesAccepted, false);
		setShowCookiePolicy(false);
	}

	return (
		<>
			{
				showCookiePolicy &&
				<Rodal 
					visible={showCookiePolicy} 
					onClose={() => setShowCookiePolicy(false)}
					showCloseButton={false}
					closeMaskOnClick={false}
					closeOnEsc={false}
					showMask={false}
					animation="slideUp"
					width={479} 
					height={387} 
					className="cookie-policy-box"
					customStyles={{ 
						position: 'fixed', 
						bottom: -300, 
						left: 900, 
						boxShadow: '0 0 10px',
						backgroundColor: 'rgb(248, 248, 248)',
						borderRadius: 2,
						padding: '50px 30px',
						fontSize: 14,
						color: '#413F3F'
					}}>
						<p style={{textAlign: 'justify', textAlignLast: 'center'}}>
							We use technical cookies to ensure the functioning of the site, analytical and profiling including third party cookies to measure the performance of the site and send targeted advertising.
							To accept cookies, click on <i>Accept</i>, to reject them click <i>Reject</i>, to select them click <i>Manage</i>. 
							For more information read our <a href="#" target="_blank">Privacy Policy</a> and our <a href="#" target="_blank">Cookie Policy</a>.
						</p>
					<button className="btn btn-secondary w-100 mt-20" onClick={handleAccept}>Accept</button>
					<button className="btn btn-secondary w-100 mt-2" onClick={handleReject}>Reject</button>
					<button className="btn btn-secondary w-100 mt-2">Manage</button>
				</Rodal>
			}
			<div className="container-fluid">
				<div className="row">
					<div className="col-3">
						<Filters />
					</div>
					<div className="col-9">
						<Products />
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
